'use strict';

import React from 'react';
import Addresses from '../components/AddressesComponent'

require('styles//Home.css');

class HomeComponent extends React.Component {
  render() {
    return (
      <div className="home-component" id="content">
        <p>Компания ТОО «Мединформ» была создана в 1995 году. В 2000 году был открыт филиал компании в Астане. Основные направления деятельности компании является:</p>
      <ul>
        <li>• разработка, внедрение и сопровождение программных продуктов для медицинских организаций и органов управления здравоохранения;</li>
        <li>• подготовка и публикация аналитических сборников о состоянии здоровья населения и здравоохранения страны;</li>
        <li>• техническое обслуживание вычислительной техники, установка и настройка ОС.</li>
      </ul>
      <p>На все программные продукты Компания “Мединформ” имеет Свидетельство о государственной регистрации объекта интеллектуальной собственности, зарегистрированных в Комитете по правам интеллектуальной собственности Министерства юстиции Республики Казахстан.</p>
      <Addresses/>
      </div>
    );
  }
}

HomeComponent.displayName = 'HomeComponent';

// Uncomment properties you need
// HomeComponent.propTypes = {};
// HomeComponent.defaultProps = {};

export default HomeComponent;



// WEBPACK FOOTER //
// ./src/components/HomeComponent.js